<template>
    <div>
        <b-modal id="robot" title="Sihirbaz" body-class="p-75" no-close-on-esc no-close-on-backdrop hide-footer>
            <calculate-salary-process-bes-robot v-on:done="$event => done($event)" :filter="filter"></calculate-salary-process-bes-robot>
        </b-modal>

        <b-modal id="detail" size="lg" title="Hesaplama Geçmişi" body-class="p-50" no-close-on-esc no-close-on-backdrop hide-footer>
            <calculate-salary-process-levy-bes-detail :detail="detail"></calculate-salary-process-levy-bes-detail>
        </b-modal>

        <b-modal id="excluded" size="lg" title="Eksikler" body-class="p-0" no-close-on-esc no-close-on-backdrop hide-footer>
            <calculate-salary-process-levy-bes-excluded :employees="excludedEmployees"></calculate-salary-process-levy-bes-excluded>
        </b-modal>

        <b-modal id="exceptional" title="Ekle" no-close-on-esc no-close-on-backdrop>
            <calculate-salary-process-bes-exceptional v-model="exceptional" :filter="filter"></calculate-salary-process-bes-exceptional>
            <template #modal-footer><v-executer :loading="exceptionalSaving" text="Kaydet" :disabled="!exceptional.SGKJobNoticeId" :action="manualSet"></v-executer></template>
        </b-modal>

        <b-card no-body class="mb-1">
            <b-overlay :show="getting" opacity="0.2">
                <div class="p-1">
                    <div class="row">
                        <div class="col-md-3 mb-1 mb-md-0">             
                            <b-input-group class="input-group-merge">
                                <template #prepend>
                                    <b-input-group-text >
                                        <feather-icon icon="SearchIcon"></feather-icon>
                                    </b-input-group-text>
                                </template>
                                <b-form-input placeholder="Ara..." v-on:keyup.enter="getData" v-model="searchValue"></b-form-input>
                            </b-input-group>
                        </div>
                        <div class="col-md-2 mb-1 mb-md-0">
                            <v-date-picker :value="salaryPaymentDate" placeholder="Tarih" v-on:change="$e => $emit('salary-payment-date',$e)"></v-date-picker>
                        </div>
                        <div class="col-md-auto mb-1 mb-md-0">
                            <button class="btn btn-success btn-block" v-on:click="getData">
                                Sorgula
                            </button>
                        </div>
                        <div class="col-md-auto mb-1 mb-md-0" v-if="(excludedEmployees || []).length">
                            <button class="btn btn-flat-warning btn-block" v-on:click="$showModal('excluded')">
                                Eksikler <b-badge class="d-inline ml-25">{{ (excludedEmployees || []).length }}</b-badge>
                            </button>
                        </div>
                        <div class="col-md-auto mb-1 mb-md-0" v-if="sira == '13'">
                            <button class="btn btn-outline-secondary btn-block" v-on:click="addExceptional">
                                Ekle
                            </button>
                        </div>
                        <div class="col-md-auto mb-1 mb-md-0 ml-auto">
                            <b-dropdown :disabled="acting" text="İşlemler" right :variant="sira == '13' && tableResult != null ? 'secondary' : 'primary'">
                                <template #button-content>
                                    <b-spinner v-if="acting" small/>
                                    <template v-else>İşlemler</template>
                                </template>
                                <b-dropdown-item v-on:click="calculate">
                                    <feather-icon icon="ZapIcon" class="mr-50"></feather-icon>
                                    Tüm Personeller İçin {{ sira == '13' ? 'BES' : 'İcra' }} Hesapla
                                </b-dropdown-item>
                                <b-dropdown-item v-on:click="startRobot" v-if="sira == '13'">
                                    <span class="material-icons-outlined text-secondary d-inline-block mr-50 f-1">auto_awesome</span>
                                    Sihirbazı Başlat
                                </b-dropdown-item>
                            </b-dropdown>
                        </div>
                    </div>
                </div>
                <template v-if="tableResult == null">
                    <div class="table-responsive">
                        <table class="table table-sm bordered-header">
                            <thead>
                                <tr>
                                    <th class="py-05">İşlemler</th>
                                    <th class="text-nowrap w-20 py-05">Sicil Numarası</th>
                                    <th class="text-nowrap w-20 py-05">Personel</th>
                                    <th class="text-nowrap w-10 py-05">Kimlik Numarası</th>
                                    <th class="text-nowrap w-10 py-05">Org. Şube</th>
                                    <th class="text-nowrap w-10 py-05">SGK Şube</th>
                                    <th class="text-nowrap w-10 py-05 text-right">Luca Tutar</th>
                                    <th class="text-nowrap w-20 py-05 text-right">TMS Tutar</th>
                                </tr>
                            </thead>
                            <tbody>
                                <template v-for="(p,i) in (datas || [])">
                                    <tr :key="i">
                                        <td>
                                            <div class="d-flex g-25 justify-content-center">
                                                <button :disabled="singleCalculating || acting" v-b-tooltip.noninteractive.bottom.hover="'Hesapla'" class="btn btn-xs btn-flat-secondary btn-icon" v-on:click="singleCalculate(p.EmployeeId)">
                                                    <b-spinner small v-if="singleCalculating && currentEmployeeId == p.EmployeeId"></b-spinner>
                                                    <feather-icon v-else icon="ZapIcon"></feather-icon>
                                                </button>
                                            </div>
                                        </td>
                                        <td>{{ $safe(p,'SICIL_NO') }}</td>
                                        <td class="text-nowrap">{{ $safe(p,'FullName') }}</td>
                                        <td>{{ $safe(p,'IdentityNumber') }}</td>
                                        <td class="p-0 border-left">
                                            <table class="table table-sm">
                                                <tr v-for="(dd,ii) in p.Datas">
                                                    <td :class="{'border-0':ii==0}">{{ $safe(dd,'OBranchName') || '-' }}</td>
                                                </tr>
                                            </table>
                                        </td>
                                        <td class="p-0 border-right">
                                            <table class="table table-sm">
                                                <tr v-for="(dd,ii) in p.Datas">
                                                    <td :class="{'border-0':ii==0}">{{ $safe(dd,'SGKBranchName') || '-' }}</td>
                                                </tr>
                                            </table>
                                        </td>
                                        <td class="p-0">
                                            <table class="table table-sm">
                                                <tr v-for="(dd,ii) in p.Datas">
                                                    <td :class="[{'border-0':ii==0,'text-danger':hasError(dd)},'text-right',]">
                                                        <div class="d-flex g-25 align-items-center">
                                                            <span class="mr-auto" v-if="!$safe(dd,'LucaStr')" >
                                                                <feather-icon v-b-tooltip.noninteractive.bottom.hover="'Bordroda ilgili tutar eksik.'" class="text-danger mr-25" icon="InfoIcon"/>
                                                            </span>
                                                            <span class="ml-auto mr-25" :class="$safe(dd,'LucaStr') ? '' : 'text-danger'">
                                                                {{ $safe(dd,'LucaStr') || '-' }}
                                                            </span>
                                                        </div>
                                                    </td>
                                                </tr>
                                            </table>                               
                                        </td>
                                        <td class="p-0">
                                            <table class="table table-sm">
                                                <tr v-for="(dd,ii) in p.Datas">
                                                    <td :class="[{'border-0':ii==0,'text-danger':hasError(dd)},'text-right',]">
                                                        <div class="d-flex g-25 align-items-center">
                                                            <button class="btn btn-xxs btn-flat-info btn-icon" :class="{'btn-flat-danger':hasError(dd)}" v-b-tooltip.noninteractive.bottom.hover="'Hesaplama Geçmişi'" v-on:click="showDetail(dd)">
                                                                <feather-icon icon="InfoIcon"></feather-icon>
                                                            </button>
                                                            <button v-if="$safe(dd,'Manual') && sira == '13'" :disabled="acting || manualDeleting" v-b-tooltip.noninteractive.bottom.hover="'Sil'" class="btn btn-xxs btn-flat-danger btn-icon" v-on:click="deleteManual(dd.ManualId,p.FullName)">
                                                                <b-spinner small v-if="manualDeleting && currentEmployeeId == p.EmployeeId"></b-spinner>
                                                                <feather-icon v-else icon="TrashIcon"></feather-icon>
                                                            </button>
                                                            <span class="ml-auto">
                                                                <feather-icon v-b-tooltip.noninteractive.bottom.hover="'Bu veri sonradan elle eklemiştir.'" v-if="$safe(dd,'Manual')" class="text-muted mr-25" icon="Edit3Icon"/>
                                                                {{ $safe(dd,'LastAmountStr') || '-' }}
                                                            </span>
                                                        </div>
                                                    </td>
                                                </tr>
                                            </table>                               
                                        </td>
                                    </tr>
                                    <!-- <tr class="border-4" :key="`d-${i}`">
                                        <td colspan="5" class="p-50">
                                            <template v-if="(p.Results || []).length == 0">
                                                Henüz bir hesaplama yapılmamış.
                                            </template>
                                            <table v-else class="table table-sm table-bordered">
                                                <tbody>
                                                    <tr class="font-weight-bolder bg-light">
                                                        <td class="w-15">İşlem Tarihi</td>
                                                        <td class="w-10">Miktar</td>
                                                        <td>Durum</td>
                                                    </tr>
                                                    <tr v-for="(r,ii) in p.Results" :key="ii">
                                                        <td class="text-nowrap">{{ $safe(r,'CalculationDateTimeStr') }}</td>
                                                        <td>{{ $safe(r,'AmountStr') }}</td>
                                                        <td>
                                                            <ul class="list-group">
                                                                <li class="list-group-item px-50 py-25 text-danger" v-for="(e,iii) in r.Errors" :key="iii">
                                                                    {{ e }}
                                                                </li>
                                                                <li class="list-group-item px-50 py-25 text-nowrap text-success" v-if="(r.Errors || []).length == 0">
                                                                    Hesaplama başarılı.
                                                                </li>
                                                            </ul>
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </td>
                                    </tr> -->
                                </template>
                                <tr v-if="(datas || []).length == 0">
                                    <td colspan="100" class="text-center">Henüz bir veri bulunmamaktadır.</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <div class="mx-75 my-1" v-if="total!='0'">
                        <div class="bg-light border rounded">
                            <div class="d-flex align-items-center p-50">
                                <div class="row justify-content-md-between justify-content-center text-success">
                                    <div class="col-auto mb-1 mb-md-0">
                                        <div class="d-flex align-items-center g-50">
                                            <span class="material-icons-outlined" >calculate</span>
                                            <b>TOPLAM: {{total || 0}}</b>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="mx-75 mb-1" v-if="count > 0">
                        <div class="row justify-content-md-between justify-content-center">
                            <div class="col-auto mb-1 mb-md-0">
                                <div class="d-flex align-items-center text-nowrap">
                                    Toplam {{(count || 0)}} kayıt arasından
                                    <select class="form-control form-control-sm mx-50 per-page-select" v-model="perPage">
                                        <option v-for="pp in perPages" :key="pp" :value="pp">{{pp}}</option>
                                    </select>
                                    gösteriliyor.   
                                </div>
                            </div>
                            <div class="col-auto mb-1 mb-md-0">
                                <b-pagination class="mb-0" v-model="page" :total-rows="((count || 0))" :per-page="perPage"></b-pagination>
                            </div>
                        </div>
                    </div>
                </template>
                <template v-else>
                    <div class="alert alert-danger mb-1 mx-1">
                        <div class="alert-body">
                            {{ $safe(tableResult,'Message') }}
                        </div>
                    </div>
                </template>
            </b-overlay>
        </b-card>
        <b-card no-body class="p-50">
            <div class="row justify-content-end">
                <div class="col-auto">
                    <button class="btn btn-sm btn-outline-secondary" v-on:click="$emit('back')">Geri</button>
                </div>
                <div class="col-auto">
                    <button class="btn btn-sm btn-secondary" v-on:click="$emit('next')">İleri</button>
                </div>
            </div>
        </b-card>
    </div>
</template>

<script>
import EmployeeOperationsApi from '@/api/employee-operations';
import { BPagination, BOverlay, BInputGroup, BInputGroupText, BFormInput, BSpinner,VBTooltip, BCard, BDropdown, BDropdownItem, BBadge } from 'bootstrap-vue'
import CalculateSalaryProcessBesRobot from './bes/CalculateSalaryProcessBesRobot.vue'
import CalculateSalaryProcessLevyBesDetail from './CalculateSalaryProcessLevyBesDetail.vue'
import CalculateSalaryProcessBesExceptional from './bes/CalculateSalaryProcessBesExceptional.vue';
import CalculateSalaryProcessLevyBesExcluded from './CalculateSalaryProcessLevyBesExcluded.vue';
import moment from 'moment'


export default{
    components:{
        BPagination,
        BOverlay,
        BInputGroup,
        BInputGroupText,
        BFormInput,
        CalculateSalaryProcessBesRobot,
        CalculateSalaryProcessLevyBesDetail,
        CalculateSalaryProcessBesExceptional,
        BSpinner,
        BCard,
        BDropdown, 
        BDropdownItem, 
        BSpinner,
        BBadge,
        CalculateSalaryProcessLevyBesExcluded
    },
    directives:{
        'b-tooltip':VBTooltip
    },
    props:{
        donem:{
            type:Object,
            default:()=>({
                year:null,
                month:null
            })
        },
        filter:{
            type:Object,
            default:() => ({})
        },
        salaryPaymentDate:{
            type:String,
            default:null
        },
        sira:String
    },
    watch:{
        "page"(oldV,newV){
            if(oldV && newV && oldV != newV){
                this.getData()
            }
        },
        "perPage"(oldV,newV){
            if(oldV && newV && oldV != newV){
                this.getData()
            }
        }
    },
    data(){
        return {
            page:1,
            perPage:10,
            perPages:[10,20,30,40,50,100],
            years:[],
            months:[
                {index:1,name:'Ocak'},
                {index:2,name:'Şubat'},
                {index:3,name:'Mart'},
                {index:4,name:'Nisan'},
                {index:5,name:'Mayıs'},
                {index:6,name:'Haziran'},
                {index:7,name:'Temmuz'},
                {index:8,name:'Ağustos'},
                {index:9,name:'Eylül'},
                {index:10,name:'Ekim'},
                {index:11,name:'Kasım'},
                {index:12,name:'Aralık'}
            ],
            datas:[],
            count:0,
            total:"0",
            getting: false,
            searchOnTableTimer:null,
            searchValue:"",
            acting:false,
            tableResult:null,
            singleCalculating: false,
            currentEmployeeId: null,
            detail:null,
            exceptional:{
                EmployeeId: null,
                TIP: 3,
                SIRA_NO: 13,
                SGKJobNoticeId: null,
                Amount: null,
                Month: this.donem.month,
                Year: this.donem.year
            },
            exceptionalSaving:false,
            manualDeleting:false,
            excludedEmployees:[]
        }
    },
    mounted(){
        this.configureYears()
    },
    methods:{
        getData(){
            this.getting = true
            EmployeeOperationsApi.EmployeeExceptionalKYKMCalculationStatusTable({
                SalaryFilter:{
                    ...this.filter,
                    Month:this.donem.month,
                    Year:this.donem.year,
                    SalaryPaymentDate:this.salaryPaymentDate,
                    PaginateRequest:{
                        IsAscending:true,
                        OrderColumnName:'FullName',
                        QueryParam:this.searchValue,
                        Skip:this.page,
                        Take:this.perPage
                    }
                },
                SIRA_NO:this.sira,
                TIP:3,
            }).then(res=> {
                if(res.data.Success){
                    this.tableResult = null
                    this.datas = res.data.Data.Data || []
                    this.count = res.data.Data.TotalCount || 0
                    this.total = res.data.Data.TotalAmountStr || "0"
                    this.excludedEmployees = res.data.Data.ExcludedEmployees || []
                }else{
                    this.tableResult = res.data
                }
                this.getting = false
            }).catch(err => {
                this.getting = false
            })
        },
        dateChange(e){
            console.log(e)
        },
        startRobot(){
            this.$showModal('robot')
        },
        done(type){
            if(type == 'close'){
                this.$hideModal('robot')
            } else if (type == 'retry'){
                this.$hideModal('robot')
                this.$showModal('robot')
            } else if (type == 'refresh'){
                this.$hideModal('robot')
                this.getData()
            }
        },
        startTimer(){
            if(this.searchValue != null){
                const search = () => {
                    clearTimeout(this.searchOnTableTimer)
                    this.searchOnTableTimer = setTimeout(()=>this.getData(),500)
                }
                clearTimeout(this.searchOnTableTimer)
                this.searchOnTableTimer = setTimeout(()=>{ search.call(this) },500)
            }
        },
        showDetail(d){
            this.detail = null
            this.detail = d
            this.$showModal('detail')
        },
        calculate(){
            this.acting = true
            EmployeeOperationsApi.EmployeeExceptionalKYKMCalculate({
                SalaryFilter:{
                    ...this.filter,
                    Month:this.donem.month,
                    Year:this.donem.year,
                    SalaryPaymentDate:this.salaryPaymentDate,
                    PaginateRequest:{
                        IsAscending:true,
                        OrderColumnName:'FullName',
                        QueryParam:this.searchValue,
                        Skip:this.page,
                        Take:this.perPage
                    }
                },
                SIRA_NO:this.sira,
                TIP:3,
            }).then(res => {
                this.$result(res)
                this.acting = false
                this.getData()
            }).catch(err => {
                this.$result(null,err)
                this.acting = false
            })
        },
        singleCalculate(id){
            this.singleCalculating = true
            this.currentEmployeeId = id
            EmployeeOperationsApi.EmployeeExceptionalKYKMCalculate({
                SalaryFilter:{
                    ...this.filter,
                    EmployeeId:id,
                    Month:this.donem.month,
                    Year:this.donem.year,
                    SalaryPaymentDate:this.salaryPaymentDate,
                    PaginateRequest:{
                        IsAscending:true,
                        OrderColumnName:'FullName',
                        QueryParam:this.searchValue,
                        Skip:this.page,
                        Take:this.perPage
                    }
                },
                SIRA_NO:this.sira,
                TIP:3,
            }).then(res => {
                this.$result(res)
                this.singleCalculating = false
                this.currentEmployeeId = null
                this.getData()
            }).catch(err => {
                this.$result(null,err)
                this.singleCalculating = false
                this.currentEmployeeId = null
            })
        },
        configureYears(){
            let years = []
            let year = 2015
            while(year <= this.donem.year){
                years.push(year)
                year ++
            }
            this.years = years
        },
        hasError(d){
            return (d.Results || []).toSorted((a, b) => {
                const dateA = moment(a.CalculationDateTimeStr,'DD.MM.YYYY hh:mm')
                const dateB = moment(b.CalculationDateTimeStr,'DD.MM.YYYY hh:mm')
                return dateB.diff(dateA)
            })[0]?.Errors?.length > 0 || false
        },
        addExceptional(){
            this.exceptional.EmployeeId = null
            this.exceptional.SGKJobNoticeId = null
            this.$showModal('exceptional')
        },
        manualSet(){
            this.exceptionalSaving = true
            EmployeeOperationsApi.EmployeeExceptionalKYKMManualSet(this.exceptional).then(res => {
                if(res.data.Success){
                    this.getData()
                    this.$hideModal('exceptional')
                }
                this.$result(res)
                this.exceptionalSaving = false
            }).catch(err => {
                this.$result(null,err)
                this.exceptionalSaving = false
            })
        },
        deleteManual(id,name){
            this.$confirm('Silmek istediğinize emin misiniz?',`Bu işlem ${name} adlı personele manuel atanmış BES atamasını silecektir.`).then(c=>{
                if(c){
                    this.manualDeleting = true
                    this.currentEmployeeId = id
                    EmployeeOperationsApi.EmployeeExceptionalKYKMManualDelete(id).then(res => {
                        if(res.data.Success){
                            this.getData()
                        }
                        this.$result(res)
                        this.manualDeleting = false
                        this.currentEmployeeId = null
                    }).catch(err => {
                        this.$result(null,err)
                        this.manualDeleting = false
                        this.currentEmployeeId = null
                    })
                }
            })
        }
    }
}
</script>